import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../services/login.service';
import { Routes,Router,RouterModule}  from '@angular/router';

import { CommonService } from '../../services/common.service';
import { AppSettings } from '../../appSettings';
@Component({
  selector: 'app-manageconverthistory',
  templateUrl: './manageconverthistory.component.html',
  styleUrls: ['./manageconverthistory.component.css']
})
export class ManageConvertHistoryComponent implements OnInit {
 getMeConvertHistoryByUserid:string = AppSettings.getMeConvertHistoryByUserid;
 model:any={}; 
 transferlist:Array<Object>;
  constructor(private loginService: LoginService,private CommonService: CommonService,private router: Router) { }

  ngOnInit() {
    this.loginService.localStorageData();
     this.loginService.viewsActivate();
     this.model.user_id=localStorage.getItem('currentUserID');
      this.CommonService.insertdata(this.getMeConvertHistoryByUserid,this.model)
    .subscribe(package_det =>{ 
        this.transferlist = package_det.result;
        this.loginService.viewCommontdataTable('dataTable','transferinfo_table');
    });
     
  }

}
